import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { loadMorePaginationProp, SimpleLoadingComponent } from '../../utils/apollo';
import RecommendationsSearchResults from './search-results';
import AddTravelPlan from '../../mutations/RepVisitsTravelPlan/addTravelPlan';

const query = gql`
  query RecommendationsSearchResults($filter: String!, $first: Int!, $after: String) {
    viewer {
      id
      repVisitsTravelPlan {
        id
        name
      }
      recommendedHighSchoolSearchByLocation(filter: $filter, first: $first, after: $after) {
        edges {
          node {
            id
            name
            recommendationScore
            interestedStudents
            address {
              field_hs_elna_state_latest
              field_hs_elna_city
              field_hs_el_county_name
            }
            enrollmentByGrade{
              field_hs_el_grade_12_students
            }
            general {
              field_hs_na_nces_id
              field_hs_elna_school_type
            }
            naviance {
              field_hs_na_nguid
              field_hs_na_percent_college
            }
            repVisitsAccount {
              id
              availabilityVisible
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
`;

const graphqlData = graphql(query, {
  options: ({ params }) => ({
    variables: {
      first: 25,
      filter: params.filter,
    },
  }),
  props: loadMorePaginationProp(query),
});

const makeMutation = (mutation, name) => graphql(mutation, { name });

export default SimpleLoadingComponent(graphqlData, makeMutation(AddTravelPlan, 'addTravelPlan'))(RecommendationsSearchResults);
